/* eslint-disable react/prop-types */
import React, {useEffect} from 'react';
import {CBForm} from '../../constants/apricotCBform';
import removeWhiteSpace from '../../constants/removeSpace';
import {ADMIN_ROLE} from '../../constants/global';
import '../SmartDisplay/SmartDisplay.scss';
import {ToolTip} from '../';
import { lockMsg, lockMsgAdmin } from '../../constants/messages';

const TextAreaInput = props => {
  const {apcp, question_tooltip, inputId, halfInput, org_rol, errorId, maxLength, errMsg='Error', successMsg='Success',
    inputLabel, requiredInput, inputName, textvalue, onChangeInputValue, readOnly, showQlock, children} = props;

  useEffect(() => {
    document.querySelectorAll('.cb-floating-label').forEach(elem => {
      CBForm.floatingLabel(elem.querySelector('textarea'));
    });
  }, []);

  return(
    <div id={`${errorId}_one`} className='fieldArrangement'>
      <div className='cb-input cb-input-condensed col-md-12 fieldInput'>
        <div id={`${errorId}_two`} className='cb-validation-label-input'>


          <div className={`display-flex ${halfInput?'col-md-12':'col-md-6'}`} >
            {children}
            <label className={`${requiredInput?'cb-required':''}`} htmlFor={`textarea`+removeWhiteSpace(inputId)}>{inputLabel}</label>
            {
              !apcp&&question_tooltip?<ToolTip tooltipid={`smartdisplaytextarea${removeWhiteSpace(inputId)}id`} 
                                        tooltipMsg={question_tooltip} 
                                        innerMsg={<span className="cb-icon cb-user"></span>} 
                                        className={'questionToolTip'}
                                        />
                                        :''
            }
          </div>

          <div className={`lineupinput ${halfInput?'col-md-12':'col-md-6'}`}>
            <textarea
              id={`textarea`+removeWhiteSpace(inputId)}
              rows='5'
              name={inputName}
              data-testid='textareaid'
              disabled={readOnly}
              aria-readonly={readOnly}
              value={textvalue}
              aria-invalid='false'
              aria-describedby=''
              aria-required={requiredInput}
              maxLength={maxLength}
              onChange={event => {
                onChangeInputValue(event.target.value);
              }} />
              {showQlock?
                <ToolTip tooltipid={`textareatooltip${inputId}`} 
                tooltipMsg={org_rol===ADMIN_ROLE?lockMsgAdmin:lockMsg} 
                className={'cb-icon cb-lock'} />:''
              }
          </div>
        </div>
      </div>
      <div className='errorDiv'>
        <p id={`${errorId}_s`} style={{display: 'none'}}>{successMsg}</p>
        <p id={`${errorId}_e`} style={{display: 'none'}}>{errMsg}</p>
      </div>
    </div>
  );
};

export default TextAreaInput;